import React from "react"

const CollapseContext = React.createContext(false)

export default CollapseContext
